export default __webpack_public_path__ + "static/media/060_corner2.3265c1cb.mp4";